import { Controller } from "@hotwired/stimulus"

// Manages the view mode (grid/list) for routine log products
export default class extends Controller {
  static targets = ["container", "gridIcon", "listIcon"]
  static values = {
    mode: { type: String, default: "grid" }
  }

  connect() {
    // Load saved preference from localStorage
    const savedMode = localStorage.getItem('routineLogViewMode')
    if (savedMode) {
      this.modeValue = savedMode
    }
    this.updateView()
  }

  toggleMode() {
    this.modeValue = this.modeValue === "grid" ? "list" : "grid"
    localStorage.setItem('routineLogViewMode', this.modeValue)
    this.updateView()
  }

  updateView() {
    // Update container classes
    this.containerTargets.forEach(container => {
      if (this.modeValue === "grid") {
        container.classList.remove("flex", "flex-col", "gap-1.5")
        container.classList.add("grid", "grid-cols-4", "lg:grid-cols-7", "gap-2.5")
      } else {
        container.classList.remove("grid", "grid-cols-4", "lg:grid-cols-7", "gap-2.5")
        container.classList.add("flex", "flex-col", "gap-1.5")
      }

      // Update products in the container
      const products = container.querySelectorAll('[data-routine-log-products-target="product"]')
      products.forEach(product => {
        const label = product.querySelector('label')
        const span = product.querySelector('span')
        const img = product.querySelector('img')

        if (this.modeValue === "grid") {
          // Grid view: square aspect ratio, centered image, no text, animations enabled
          label?.classList.remove("flex-row", "w-full", "aspect-auto", "px-2", "py-1", "rounded-xl", "ring-1")
          label?.classList.add("aspect-square", "lg:hover:scale-105", "rounded-2xl", "ring-2")
          span?.classList.add("hidden")
          img?.classList.remove("size-8", "mr-2")
          img?.classList.add("size-16", "mr-0")
        } else {
          // List view: horizontal layout, show product name, animations disabled, condensed
          label?.classList.remove("aspect-square", "lg:hover:scale-105", "rounded-2xl", "ring-2")
          label?.classList.add("flex-row", "w-full", "aspect-auto", "px-2", "py-1", "rounded-xl", "ring-1")
          span?.classList.remove("hidden")
          img?.classList.remove("size-16", "mr-0")
          img?.classList.add("size-8", "mr-2")
        }
      })

      // Update Add button styling - remove shadow, rounding, ring, and background
      const addButton = container.querySelector('[data-routine-log-products-target="addButton"]')
      if (addButton) {
        addButton.classList.remove("rounded-2xl", "ring-2", "shadow-card", "bg-white", "lg:hover:scale-105")
        addButton.classList.add("rounded-none", "ring-0", "shadow-none", "bg-transparent", "lg:hover:scale-100")
      }
    })

    // Update toggle button icons
    if (this.hasGridIconTarget && this.hasListIconTarget) {
      if (this.modeValue === "grid") {
        this.gridIconTarget.classList.add("hidden")
        this.listIconTarget.classList.remove("hidden")
      } else {
        this.gridIconTarget.classList.remove("hidden")
        this.listIconTarget.classList.add("hidden")
      }
    }
  }
}
